import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export type InfoBoxVariant = 'warning' | 'info' | 'success' | 'error' | 'neutral';

const VARIANT_ICON_DEFAULTS: { [key: string]: string } = {
  warning: 'warning',
  info: 'info',
  success: 'check_circle',
  error: 'error',
  neutral: null
};

@Component({
  selector: 'csi-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoBoxComponent {
  @Input() variant: InfoBoxVariant = 'info';
  @Input() icon: string;
  @Input() showBorder = true;
  @Input() compact = false;

  get resolvedIcon(): string {
    if (this.icon === 'none') {
      return null;
    }
    if (this.icon) {
      return this.icon;
    }
    return VARIANT_ICON_DEFAULTS[this.variant] || null;
  }
}
